import { PolicyCategory, PolicyId, PolicyType } from '../types';

/**
 * Request payload for the policy conflicts API endpoint.
 * Defined here to avoid circular dependency with usePolicyConflicts.
 */
export interface PolicyConflictsRequest {
  /** ID of the current policy being edited (null for new policies) */
  policyId: PolicyId | null;
  /** Type of policy being created/edited */
  type: PolicyType;
  /** IDs of environment groups to check for conflicts */
  environmentGroups: Array<number>;
}

export const queryKeys = {
  base: ['policies'] as const,
  // 'list' is its own segment so invalidating the list never prefix-matches a
  // detail key ([...base, id]).
  list: () => [...queryKeys.base, 'list'] as const,
  detail: (id: PolicyId) => [...queryKeys.base, id] as const,
  metadata: () => [...queryKeys.base, 'metadata'] as const,
  conflicts: (request: PolicyConflictsRequest) =>
    [...queryKeys.base, 'conflicts', request] as const,
  templates: (filters?: { category?: PolicyCategory; type?: PolicyType }) =>
    [...queryKeys.base, 'templates', filters] as const,
};
